<template>
  <div class="content-section no-padding-top" id="favorite-ann-list-template">
    <div class="job-list-container">
      <!-- 데이터가 있는 경우 -->
      <div v-if="normalizedDisplayedList.length > 0">
        <div class="job-card-grid new-type">
          <JobCard
            v-for="(item, index) in normalizedDisplayedList"
            :key="index"
            :item="item"
            :show-mark="false"
            @favorite-toggle="toggleFavorite"
          >
            <template #title>
              <h3 class="title-line" v-html="item.ANN_NM"></h3>
            </template>
            <template #details>
              <p class="job-details" v-html="item.jobDetail"></p>
            </template>
            <template #recruitment-info>
              <dl class="recruitment-info">
                <dt>모집인원 : </dt><dd>{{ item.rcptPpl }}명</dd>
                <dt>모집기간 : </dt><dd>{{ item.APPDURNG_STED }}</dd>
              </dl>
            </template>
          </JobCard>
        </div>
        <div class="button-area btn-load-more" v-if="totalCount > viewCount">
          <button type="button" @click="more">
            <i class="ico ico-plus"></i>
            더보기
          </button>
        </div>
      </div>

      <!-- 데이터가 없는 경우 -->
      <div class="no-data" v-else-if="totalCount == 0">
        관심 일자리로 등록한 공고가 없습니다.
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import JobCard from '../components/JobCard.vue';

const workCondition = {
  IN60001: '정규직',
  IN60002: '계약직',
  IN60003: '인턴직',
  IN60004: '파트타임',
  IN60005: '기타',
};

const careerHistory = {
  ANY: '경력무관',
  NEW: '신입',
  EXPERIENCED: '경력',
};

export default {
  name: 'favorite-ann-list-template',
  props: ['isLogin'],
  components: {
    JobCard,
  },
  data() {
    return {
      list: [],
      viewCount: 12,
      totalCount: 0,
      workCondition,
      careerHistory,
    };
  },
  computed: {
    displayedList() {
      return this.list.slice(0, this.viewCount);
    },
    normalizedDisplayedList() {
      return this.displayedList.map(item => ({
        ...item,
        // JobCard가 기대하는 필드명으로 변환
        ANN_NM: item.annNm,
        BIZ_SE: (item.annInfo && item.annInfo.BIZ_SE) || '',
        BIZ_SE_NM: (item.annInfo && item.annInfo.BIZ_SE_NM) || '',
        OPER_ORG_NM: (item.annInfo && item.annInfo.OPER_ORG_NM) || '',
        rcptPpl: item.recruitCount,
        APPDURNG_STED: item.recruitDate,
        FAVORITE_YN: (item.annInfo && item.annInfo.FAVORITE_YN) || 'N',
        DDAY: item.dDay,
        // 상태 변환
        ANN_RCRT_STAT: this.convertStatusToCode(item.annRcrtStat),
      }));
    },
  },
  watch: {},
  methods: {
    convertStatusToCode(status) {
      // 상태를 JobCard가 기대하는 코드로 변환
      switch (status) {
        case 'IN_PROGRESS':
          return '17003';
        case 'SCHEDULED':
          return '17002';
        case 'CLOSED':
          return '17004';
        case 'RECRUITING':
          return '17001';
        default:
          return '';
      }
    },
    getRecruitmentStatus(status) {
      if (status.includes('17001')) {
        return 'RECRUITING';
      }
      if (status.includes('17002')) {
        return 'SCHEDULED';
      }
      if (status.includes('17003')) {
        return 'IN_PROGRESS';
      }
      if (status.includes('17004')) {
        return 'CLOSED';
      }
      return null;
    },
    getJobDetail(type, info) {
      let detail = '';
      if (type === 'JB') {
        detail += `운영기관 : ${info.OPER_ORG_NM}<br>사업구분 : ${info.BIZ_SE_NM}`;
      } else if (type === 'IN') {
        if (info.ACTAMT_HAMT != null) {
          detail += `활동비 시급 : ${info.ACTAMT_HAMT.toLocaleString('ko-KR')}원<br>`;
        }
        if (info.WORK_CONDITION != null) {
          detail += `${this.workCondition[info.WORK_CONDITION]}<span class="bar"></span>`;
        }
        if (info.CAREER_HISTORY != null) {
          detail += this.careerHistory[info.CAREER_HISTORY];
        }
      }
      return detail;
    },
    getList() {
      const params = {
        detail: true,
      };
      Axios.get('/api/favorite-anns', { params })
        .then((response) => {
          const favoriteList = response.data.map((fav) => {
            const annInfo = fav.annInfo || {};
            return {
              ...fav,
              annNm: annInfo.ANN_NM,
              viewUrl: (fav.annType === 'JB')
                ? `/appView.do?ANN_NO=${fav.annNo}`
                : `/in_appView.do?ANN_NO=${fav.annNo}`,
              jobDetail: this.getJobDetail(fav.annType, annInfo),
              recruitCount: annInfo.RCRT_PPL,
              recruitDate: annInfo.APPDURNG_STED,
              annRcrtStat: this.getRecruitmentStatus(annInfo.ANN_RCRT_STAT || ''),
              dDay: annInfo.DDAY,
            };
          });
          this.list = [...this.list, ...favoriteList];
          this.totalCount = this.list.length;
        }).catch((e) => {
          console.log(e);
        });
    },
    more() {
      this.viewCount += 8;
    },
    toggleFavorite(item) {
      if (!this.isLogin) {
        alert('로그인 후 이용 가능합니다.');
        return;
      }

      const isFavorite = item.annInfo.FAVORITE_YN === 'Y';
      const confirmText = isFavorite ? '취소' : '등록';
      if (!confirm(`해당 공고를 관심 ${confirmText}하시겠습니까?`)) {
        return;
      }

      const method = isFavorite ? 'DELETE' : 'POST';
      Axios({
        url: `/api/favorite-anns/${item.annType}/${item.annNo}`,
        method,
      }).then(() => {
        // 찜하기 취소 시 목록에서 제거
        if (isFavorite) {
          this.list = this.list.filter(i => i.id !== item.id);
        }
      }).catch((error) => {
        const errorMessage = (error.response && error.response.data && error.response.data.message) || '처리 중 오류가 발생했습니다. 다시 시도해 주세요.';
        alert(errorMessage);
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>



// WEBPACK FOOTER //
// FavoriteAnnList.vue?6ddb38fc